import { render } from "./zhiye-lesson.vue?vue&type=template&id=295490a0&scoped=true"
import script from "./zhiye-lesson.vue?vue&type=script&lang=js"
export * from "./zhiye-lesson.vue?vue&type=script&lang=js"

import "./zhiye-lesson.vue?vue&type=style&index=0&id=295490a0&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-295490a0"]])

export default __exports__